exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._36y8qNcAeeIXQcJwb7ScgR {\n    width: 100%;\n    height: 100%;\n    background-color: darkcyan;\n    border: red solid 5px;\n}\n\n.b2NitNsvCb9npj4GQ1p25 {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: #FFFFFF;\n}\n\n._2-REAZEcZKnLIE0s97Yiq1 {\n    width: 55%;\n}\n", ""]);

// Exports
exports.locals = {
	"cytoscape-container": "_36y8qNcAeeIXQcJwb7ScgR",
	"warning-container": "b2NitNsvCb9npj4GQ1p25",
	"warning-message-box": "_2-REAZEcZKnLIE0s97Yiq1"
};